import React, { useMemo } from 'react';
import { CommentContext, CommentContextProps, commentSlice } from '../context/CommentContext';
import { Comment } from '../types/comment';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';

interface CommentProviderProps {
  children: React.ReactNode;
}

export default function CommentProvider({ children }: CommentProviderProps) {
  const dispatch = useAppDispatch();
  const items = useAppSelector(state => state.comments.items);
  const loading = useAppSelector(state => state.comments.loading);

  const comments = useMemo(() => {
    const map = new Map();
    for (const item of items) {
      const comment = new Comment(item);
      const index = comment.parentId || comment.id;
      const existing = map.get(index);
      map.set(index, existing ? existing.set(comment.id, comment) : new Map([[comment.id, comment]]));
    }
    return map;
  }, [items]);

  const commentContext: CommentContextProps = {
    comments,
    commentsLoading: loading,
    setComments: (comments: Map<string, Map<string, Comment>>) =>
      dispatch(commentSlice.actions.set([...comments.values()].flatMap(m => [...m.values()]))),
  };

  return <CommentContext.Provider value={commentContext}>{children}</CommentContext.Provider>;
}
